// extracted by mini-css-extract-plugin
module.exports = {"dashed-seperator":"LoadMore_dashed-seperator__bWJkJ","load-more-btn":"LoadMore_load-more-btn__TJzUD"};